import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateAdminUser } from './updateAdminUser';
import { UserListRequestPayload, UserMutationPayload } from './types'
import { COMPANY_API_SETTINGS_MOCKED } from '@/env';
import { QUERY_KEY_SETTINGS_ADMIN_PANEL } from '@/lib/api/constants';

type Props = {
    userIdToUpdate: string
    filters: UserListRequestPayload
    payload: UserMutationPayload
}

export function useMutationAdminUserUpdate(companyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ userIdToUpdate, payload }: Props) => {
      if (COMPANY_API_SETTINGS_MOCKED) {
        return { success: true }
      }
      const { data } = await updateAdminUser({ companyId, userIdToUpdate, payload })
      return data;
    },

    onError: (error) => {
      // @TODO handle error properly
      // show notification to user
      // @TODO display notification
      console.error('Error useMutationAlertRemindersConfiguration:', error);
    },

    onSuccess: (_, { filters }) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY_SETTINGS_ADMIN_PANEL, 'users', companyId, filters] });
    //   queryClient.setQueryData([QUERY_KEY_SETTINGS_ADMIN_PANEL, 'companies', companyId], saved)
    },
  });
}
